import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Flex,
  Spinner,
  useToast,
    AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAdmin } from "../../context/AdminContext";
import {trackClick} from '../../ga'

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true); 
  const navigate = useNavigate();
  const toast = useToast();
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const { isAdmin, logout } = useAdmin();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const cancelRef = useRef();
  
  useEffect(() => {
    if (!isAdmin) {
      navigate("/admin/login");
    }
  }, [isAdmin, navigate]);


  const fetchMessages = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token missing");

    const res = await axios.get("https://itracks-api-prod-22dc11310f73.herokuapp.com/api/messages", {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("Fetched messages:", res.data); 

    setMessages(res.data);
  } catch (error) {
    console.error("Fetch error:", error);
    toast({
      title: isArabic ? "فشل تحميل الرسائل" : "Failed to load messages",
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  } finally {
    setLoading(false);
  }
};


  const deleteAllMessages = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete("https://itracks-api-prod-22dc11310f73.herokuapp.com/api/messages", {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast({
        title: isArabic ? "تم حذف جميع الرسائل" : "Message has been successfully deleted",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      setMessages([]);
    } catch (error) {
      toast({
        title: isArabic ? "فشل الحذف" : "Failed to delete messages",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (isAdmin) {
      fetchMessages();
    }
  }, [isAdmin]);

  if (!isAdmin) {
    return null; 
  }

  if (loading) {
    return (
      <Box py={20} px={6} minH="100vh" display="flex" justifyContent="center" alignItems="center">
        <Spinner size="xl" color="orange.500" />
      </Box>
    );
  }

  
// To confirm delete 
  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);
  const confirmDelete = async () => {
    closeDialog();
    await deleteAllMessages();
  };


  return (
    <Box py={20} px={6} bgGradient="linear(to-b, #ffffff, #2f4280)" minH="100vh"  onClick={() => trackClick(`Clicked messages page`)}>
      <Box maxW="6xl" mx="auto" bg="white" p={8} borderRadius="xl" boxShadow="xl">

        <Flex justify="space-between" align="center" mb={6}>
          <Heading color="#2f4280">
            {isArabic ? "أهلاً بك" : "Welcome Admin"}
          </Heading>
          <Button onClick={logout} colorScheme="red">
            {isArabic ? "تسجيل الخروج" : "Logout"}
          </Button>
        </Flex>

        <Button mb={4} colorScheme="red" onClick={openDialog}>
          {isArabic ? "حذف جميع الرسائل" : "Delete All Messages"}
        </Button>


        {messages.length === 0 ? (
          <Text>{isArabic ? "لا توجد رسائل" : "No messages found."}</Text>
        ) : (
          <Table variant="striped" colorScheme="gray">
            <Thead>
              <Tr>
                <Th>{isArabic ? "الاسم" : "Name"}</Th>
                <Th>{isArabic ? "رقم الجوال" : "Phone"}</Th>
                <Th>{isArabic ? "البريد الإلكتروني" : "Email"}</Th>
                <Th>{isArabic ? "الرسالة" : "Message"}</Th>
              </Tr>
            </Thead>
            <Tbody>
              {messages.map((msg, index) => (
                <Tr key={index}>
                  <Td>{msg.name}</Td>
                  <Td>{msg.phone}</Td>
                  <Td>{msg.email}</Td>
                  <Td>{msg.message}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}


      </Box>
      <AlertDialog
  isOpen={isDialogOpen}
  leastDestructiveRef={cancelRef}
  onClose={closeDialog}
>
  <AlertDialogOverlay>
    <AlertDialogContent>
      <AlertDialogHeader fontSize="lg" fontWeight="bold">
        {isArabic ? "تأكيد الحذف" : "Confirm Deletion"}
      </AlertDialogHeader>

      <AlertDialogBody>
        {isArabic
          ? "هل أنت متأكد أنك تريد حذف جميع الرسائل؟ هذا الإجراء لا يمكن التراجع عنه."
          : "Are you sure you want to delete all messages? This action cannot be undone."}
      </AlertDialogBody>

      <AlertDialogFooter>
        <Button ref={cancelRef} onClick={closeDialog}>
          {isArabic ? "إلغاء" : "Cancel"}
        </Button>
        <Button colorScheme="red" onClick={confirmDelete} ml={3}>
          {isArabic ? "نعم، حذف" : "Yes, Delete"}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialogOverlay>
</AlertDialog>

    </Box>
  );
}
